'use strict';

$(document).ready(function () {
  var $window = $(window);
  var $body = $(document.body);

  // Timing constants
  var TIMING = {
    SLIDE_DELAY: 260,
    CENTER_DELAY: 200,
    RESET_DELAY: 1500,
    SCROLL_DURATION: 400,
    LAYOUT_DELAY: 500
  };

  // CSS.escape polyfill for older browsers
  function escapeCSS(value) {
    if (typeof CSS !== 'undefined' && CSS.escape) {
      return CSS.escape(value);
    }
    return value.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
  }

  /**
   * Sidebar
   */
  var $sidebar = $('#sidebar');
  var $sidebarContent = $('#sidebar-content');
  var $sidebarSections = $('#sidebar li.section');
  var $sidebarActiveSection = $('#sidebar li.section.active');

  // Get the scrollable container
  function getSidebarContainer() {
    var $scrollWrapper = $('#sidebar .scroll-wrapper');
    var $scrollContent = $scrollWrapper.find('.scroll-content');
    var container = ($scrollContent.length ? $scrollContent : $scrollWrapper)[0];
    return container || null;
  }

  // Simple smooth scroll
  function scrollSidebarTo(target, duration) {
    var container = getSidebarContainer();
    if (!container) {
      return;
    }
    $(container).animate({ scrollTop: target }, duration || TIMING.SCROLL_DURATION);
  }

  // Center active topic on load
  function centerActiveTopic() {
    try {
      var container = getSidebarContainer();
      var $activeTopic = $('#sidebar li.section.active li.topic.active');

      if (!container || !$activeTopic.length || !$activeTopic[0] || !$activeTopic.is(':visible')) {
        return;
      }

      var topicTop = $activeTopic[0].offsetTop;
      var containerHeight = container.clientHeight;
      var center = topicTop - containerHeight / 2;

      scrollSidebarTo(Math.max(0, center), TIMING.SCROLL_DURATION);
    } catch (e) {
      // Ignore errors
    }
  }

  // Toggle sidebar sections
  $sidebarSections.each(function () {
    var $section = $(this);
    var $topics = $section.children('ul.topics');

    $section.children('a').click(function (e) {
      e.preventDefault();

      // Toggle the clicked section
      $section.toggleClass('open').attr('aria-expanded', $section.hasClass('open'));
      $topics.slideToggle('fast');

      // Close other sections
      $sidebarSections
        .not($section)
        .removeClass('open')
        .attr('aria-expanded', 'false')
        .children('ul.topics')
        .slideUp('fast');

      // Scroll opened section to top with offset
      if ($section.hasClass('open')) {
        setTimeout(function () {
          var sectionOffset = 20; // Offset from top
          scrollSidebarTo($section[0].offsetTop - sectionOffset, TIMING.SCROLL_DURATION);
        }, TIMING.SLIDE_DELAY);
      }

      return false;
    });
  });

  // Mouse hover behaviors - clear timers on enter, set return timer on leave
  var resetSidebar = null;
  $sidebar.mouseenter(function () {
    if (resetSidebar) {
      clearTimeout(resetSidebar);
      resetSidebar = null;
    }
  });
  $sidebar.mouseleave(function () {
    resetSidebar = setTimeout(function () {
      if (!$sidebarActiveSection.hasClass('open')) {
        $sidebarActiveSection.children('a').click();
      }
      resetSidebar = null;
    }, TIMING.RESET_DELAY);
  });

  // Initialize sidebar
  if ($sidebarContent.length) {
    $sidebarContent.scrollbar();

    // Center active topic after layout is ready
    setTimeout(function () {
      var $activeSection = $('#sidebar li.section.active');
      if ($activeSection.length && !$activeSection.hasClass('open')) {
        $activeSection.addClass('open').attr('aria-expanded', 'true');
        $activeSection.children('ul.topics').show();
      }
      // Use requestAnimationFrame for better timing
      if (window.requestAnimationFrame) {
        requestAnimationFrame(function () {
          setTimeout(centerActiveTopic, TIMING.CENTER_DELAY);
        });
      } else {
        setTimeout(centerActiveTopic, TIMING.CENTER_DELAY);
      }
    }, TIMING.LAYOUT_DELAY);

    $window.resize(function () {
      $('#sidebar .scroll-wrapper').height(
        $sidebar.height() - $sidebarContent.position().top - $('#sidebar > div.filter').outerHeight()
      );
    });
  }

  /**
   * TOC
   */
  var $toc = $('#toc');
  var $tocContent = $('#toc-content');
  var isAuthPage = !!document.querySelector('#authenticated-content');

  // Helper: compute vertical offset needed when scrolling (accounts for fixed nav + auth toolbar)
  function getScrollOffset() {
    var base = 80; // height of top nav
    if ($('body').hasClass('api')) {
      var authH = $('#sandbox-authentication').outerHeight() || 0;
      base += authH;
    }
    return base;
  }

  // Show TOC container (skip for auth-gated pages as auth-ui.js handles it).
  // Don't require H2 specifically: some pages (e.g. downloads/icons) are H4-heavy but still
  // want an "On this page" TOC.
  if (!isAuthPage && $tocContent.length) {
    var hasTocHeadings = $('#content').find('h2,h3,h4').not('.toc-ignore').length > 0;
    if (hasTocHeadings) {
      $toc.removeClass('hidden toc-empty');
    } else {
      $toc.addClass('toc-empty').addClass('hidden');
    }
  }

  // Initialize tocify (skip for auth-gated pages as auth-ui.js handles it).
  // Only run on pages that actually include a TOC container (#toc-content).
  // This avoids unnecessary polling (and dev warnings) on pages that don't render a TOC.
  if (!isAuthPage && $tocContent.length) {
    var isDevHost = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    function devWarn() {
      try {
        if (!isDevHost) return;
        if (console && console.warn) console.warn.apply(console, arguments);
      } catch (e) { /* ignore */ }
    }

    var tocifyRetryCount = 0;
    var maxTocifyRetries = 20; // Maximum 2 seconds of retries (20 * 100ms)

    // Tocify can drop headings when the document "skips" levels (e.g. H2 -> H4).
    // Guide pages sometimes do this for visual hierarchy, so we normalize the structure
    // *for tocify only* by inserting zero-height proxy headings.
    function normalizeGuideTocHeadings() {
      if (!$('body').hasClass('guide')) return;
      if (!$('#content').length) return;

      // Avoid double-processing if initTocify runs more than once due to retries.
      if ($('#content').data('toc-normalized')) return;
      $('#content').data('toc-normalized', true);

      var hasH3SinceLastH2 = false;
      $('#content').find('h2,h3,h4').each(function () {
        var tag = this.tagName ? this.tagName.toLowerCase() : '';
        if (tag === 'h2') {
          hasH3SinceLastH2 = false;
          return;
        }
        if (tag === 'h3') {
          hasH3SinceLastH2 = true;
          return;
        }
        if (tag === 'h4' && !hasH3SinceLastH2) {
          var $h4 = $(this);
          if ($h4.hasClass('toc-ignore')) return;

          // Insert a proxy H3 (zero height) so tocify has a parent level to attach to.
          // We keep the real H4 visible and ignore it in tocify so the TOC entry is not duplicated.
          var $proxy = $('<h3 class="toc-proxy-heading" aria-hidden="true"></h3>');
          $proxy.html($h4.html());

          // Preserve existing [data-unique] anchor structure used for heading permalink icons.
          // Many pages have: <div data-unique="..."></div><h4>...</h4>
          // If we insert between them, we break the permalink icon on the visible heading.
          var $prev = $h4.prev();
          if ($prev.length && $prev.is('[data-unique]')) {
            $proxy.insertBefore($prev);
          } else {
            $proxy.insertBefore($h4);
          }

          $proxy.css({
            height: 0,
            overflow: 'hidden',
            margin: 0,
            padding: 0,
            border: 0,
            fontSize: 0,
            lineHeight: 0
          });

          $h4.addClass('toc-ignore');
        }
      });
    }

    function initTocify() {
      if (typeof $.fn.tocify !== 'undefined' && $tocContent.length) {
        try {
          normalizeGuideTocHeadings();
          $tocContent.tocify({
            showAndHide: $('body').hasClass('guide'),
            hashGenerator: 'pretty',
            context: '#content',
            selectors: 'h2,h3,h4',
            ignoreSelector: '.toc-ignore',
            showEffect: 'slideDown',
            showEffectSpeed: 'fast',
            hideEffect: 'slideUp',
            hideEffectSpeed: 'fast',
            theme: 'none',
            scrollTo: getScrollOffset()
          });

          // Guide pages: tocify collapses sub-sections by default, but it doesn't provide
          // a visible affordance. Add a class to headers that have sub-items so CSS can
          // render a chevron, and keep it in sync as sections toggle.
          if ($('body').hasClass('guide')) {
            (function setupGuideTocCollapseIndicators() {
              try {
                if ($('#toc-content').data('toc-indicators-ready')) return;
                $('#toc-content').data('toc-indicators-ready', true);
              } catch (e) { /* ignore */ }

              function update() {
                try {
                  var $headers = $('#toc-content > ul.tocify-header');
                  $headers.each(function () {
                    var $ul = $(this);
                    var $headerItem = $ul.children('li.tocify-item').first();
                    var $sub = $ul.children('ul.tocify-subheader').first();
                    if (!$headerItem.length) return;
                    if ($sub.length) {
                      var subEl = $sub[0];
                      var subVisible = false;
                      try {
                        // Use real rendered visibility (tocify uses display:none).
                        subVisible = !!(subEl && subEl.offsetParent !== null && window.getComputedStyle(subEl).display !== 'none');
                      } catch (e) { /* ignore */ }
                      $headerItem.addClass('toc-has-children');
                      $headerItem.toggleClass('toc-expanded', subVisible);
                      $headerItem.toggleClass('toc-collapsed', !subVisible);
                    } else {
                      $headerItem.removeClass('toc-has-children toc-expanded toc-collapsed');
                    }
                  });
                } catch (e) { /* ignore */ }
              }

              function enforceInitialCollapsedState() {
                try {
                  // Collapse all sections by default, unless tocify already opened one.
                  var $subs = $('#toc-content > ul.tocify-header > ul.tocify-subheader');
                  if (!$subs.length) return;

                  // Keep the section containing the focused/active item open (deep links).
                  var $keepOpen = $subs.filter(function () {
                    return $(this).find('li.tocify-item.tocify-focus, li.tocify-item.active, li.active').length > 0;
                  }).first();

                  $subs.each(function () {
                    if ($keepOpen.length && this === $keepOpen[0]) return;
                    this.style.display = 'none';
                  });
                } catch (e) { /* ignore */ }
              }

              // Initial pass after tocify writes DOM.
              setTimeout(update, 0);
              // Tocify may apply its initial hide/show after initialization; run once more shortly after.
              setTimeout(update, 100);
              // If tocify did not collapse anything (or the page renders a deep-link expanded state),
              // normalize to "collapsed by default" behavior.
              setTimeout(function () {
                enforceInitialCollapsedState();
                update();
              }, 150);
              // Update after toggles.
              $('#toc-content').off('click.soracomTocIndicators').on('click.soracomTocIndicators', 'ul.tocify-header > li.tocify-item.toc-has-children > a', function () {
                var $ul = $(this).closest('ul.tocify-header');
                var $sub = $ul.children('ul.tocify-subheader').first();
                var wasVisible = false;
                try {
                  var el = $sub[0];
                  wasVisible = !!(el && el.offsetParent !== null && window.getComputedStyle(el).display !== 'none');
                } catch (e) { /* ignore */ }

                setTimeout(update, 0);
                // Tocify toggles display after its own handler runs; update again shortly after.
                setTimeout(function () {
                  // If tocify didn't actually toggle (some pages/scripts/styles can interfere),
                  // fall back to a manual toggle so the guide TOC still behaves as collapsible.
                  try {
                    var el2 = $sub[0];
                    if (el2) {
                      var nowVisible = !!(el2.offsetParent !== null && window.getComputedStyle(el2).display !== 'none');
                      if (nowVisible === wasVisible) {
                        // Toggle manually (instant; avoid fighting tocify's animations).
                        el2.style.display = wasVisible ? 'none' : 'block';
                      }
                    }
                  } catch (e) { /* ignore */ }
                  update();
                }, 90);
              });

              // Keep state in sync even if tocify toggles via animations or internal timers.
              try {
                var root = document.getElementById('toc-content');
                if (root && window.MutationObserver) {
                  var pending = false;
                  var obs = new MutationObserver(function (mutations) {
                    for (var i = 0; i < mutations.length; i++) {
                      var m = mutations[i];
                      var t = m && m.target;
                      if (!t || t.nodeType !== 1) continue;
                      if (t.classList && t.classList.contains('tocify-subheader')) {
                        if (!pending) {
                          pending = true;
                          requestAnimationFrame(function () {
                            pending = false;
                            update();
                          });
                        }
                        return;
                      }
                    }
                  });
                  obs.observe(root, { subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
                }
              } catch (e) { /* ignore */ }
            }());
          }
        } catch (e) {
          devWarn('[toc] tocify init failed; TOC will not be available', e && e.message ? e.message : e);
        }
      } else if (typeof $.fn.tocify === 'undefined' && tocifyRetryCount < maxTocifyRetries) {
        // Retry after a short delay if tocify isn't loaded yet
        tocifyRetryCount++;
        setTimeout(initTocify, 100);
      } else if (typeof $.fn.tocify === 'undefined' && tocifyRetryCount >= maxTocifyRetries) {
        devWarn('[toc] tocify did not load after retries; giving up');
      }
    }
    initTocify();
  }

  // Update TOC height on window resize
  if ($tocContent.length) {
    $tocContent.scrollbar();
    $window.resize(function () {
      $('#toc .scroll-wrapper').height($toc.height() - $tocContent.position().top);
    });
  }

  /**
   * Toolbar, sidebar, TOC
   */

  // Toggle toolbar, sidebar, or TOC on mobile
  $('[data-toggle]').click(function () {
    if (!$body.hasClass($(this).data('toggle'))) {
      $body.removeClass('toolbar sidebar toc');
    }
    $body.toggleClass($(this).data('toggle'));

    // Close authentication panels when burger menu is clicked
    if ($(this).data('toggle') === 'sidebar' && $('#sandbox-authentication').length) {
      setTimeout(function () {
        $('#sandbox-authentication .panel.open').removeClass('open');
        $('#sandbox-authentication .menu.open, #sandbox-authentication .menu.active').removeClass('open active');
      }, 10);
    }

    return false;
  });

  // Close toolbar, sidebar, or TOC on mobile
  $('#overlay').click(function () {
    $body.removeClass('toolbar sidebar toc');
    return false;
  });

  // Initialize sidebar and TOC heights
  setTimeout(function () {
    $window.trigger('resize');
  }, 250);

  /**
   * Header anchors
   */

  // Anchor scroll function - uses dynamic offset calculation
  function scrollPage($anchor) {
    var target = $anchor.offset().top - getScrollOffset();
    $([document.documentElement, document.body]).stop(true).animate(
      { scrollTop: target },
      { duration: 450, easing: 'swing' }
    );
  }

  function copyAnchorLink(href) {
    if (!href) return;
    var text = window.location.origin + window.location.pathname + href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(function () {});
    }
  }

  // Append 🔗 links to headers and add clipboard handler
  // Works for both dev docs and API reference pages
  setTimeout(function () {
    function appendAnchorLink($header, href) {
      if (!$header || !$header.length) return;
      // Skip if already has an anchor link
      if ($header.find('.anchor-link').length > 0) return;

      var $anchor = $('<a />', { href: href, 'class': 'anchor-link' }).append('<i class="fa fa-link"></i>');
      $anchor.on('click', function (e) {
        e.preventDefault();
        // Copy to clipboard if available
        if (navigator.clipboard && navigator.clipboard.writeText) {
          copyAnchorLink(href);
        }
        // Update URL hash
        if (location.hash !== href) {
          if (history.pushState) {
            history.pushState(null, null, href);
          } else {
            location.hash = href; // fallback for older browsers
          }
        }
        // Scroll to anchor - use marker only if it maps to this header
        var $marker = $header.prevAll('[data-unique]').first();
        var $nextHeading = $marker.length ? $marker.nextAll('h2,h3,h4').first() : $();
        var isMappedMarker = $marker.length && $nextHeading.length && $nextHeading[0] === $header[0];
        var $target = isMappedMarker ? $marker : $header;
        if ($target.length && $target.offset()) {
          scrollPage($target);
        }
      });
      $header.append($anchor);
    }

    function shouldSkipHeaderForAnchors($header) {
      // Skip certain headers that shouldn't have anchors (like navigation headers)
      var headerId = $header.attr('id');
      if (headerId && (headerId === 'guides' || headerId === 'docs' || headerId.indexOf('nav-') === 0)) return true;
      if ($header.hasClass('toc-proxy-heading')) return true;
      // Auth/sign-in panel headers are UI labels, not document sections.
      if ($header.hasClass('auth-section-header') || $header.hasClass('auth-overlay-heading')) return true;
      if ($header.closest('#sandbox-authentication').length > 0 || $header.closest('#auth-overlay').length > 0) return true;
      return false;
    }

    // Handle headers with data-unique elements (primary method).
    // NOTE: Some pages insert additional elements between the data-unique marker and the heading.
    // Use a robust association: for each heading, find the nearest preceding [data-unique] whose
    // next heading is this heading.
    $('#content h2, #content h3, #content h4').each(function () {
      var $header = $(this);
      if ($header.find('.anchor-link').length > 0) return;
      if (shouldSkipHeaderForAnchors($header)) return;

      // Never inject anchors into Swagger UI-rendered headings; deepLinking/Swagger handles those
      // and we intentionally avoid duplicates.
      if ($('body').hasClass('api') && $header.closest('#api').length) return;

      var $marker = $header.prevAll('[data-unique]').first();
      if (!$marker.length) return;

      var $nextHeading = $marker.nextAll('h2,h3,h4').first();
      if (!$nextHeading.length || $nextHeading[0] !== $header[0]) return;

      var unique = $marker.data('unique');
      if (!unique) return;
      var href = '#' + unique;
      appendAnchorLink($header, href);
    });

    // Docs/guides: some headings don't have data-unique markers. Ensure they still get anchors by id.
    if ($('body').hasClass('doc') || $('body').hasClass('guide') || $('body').hasClass('icons')) {
      $('#content h2, #content h3, #content h4').each(function () {
        var $header = $(this);
        if ($header.find('.anchor-link').length > 0) return;
        if (shouldSkipHeaderForAnchors($header)) return;

        // If a preceding data-unique marker maps to this header, the primary method already handles it.
        var $marker = $header.prevAll('[data-unique]').first();
        if ($marker.length) {
          var $nextHeading = $marker.nextAll('h2,h3,h4').first();
          if ($nextHeading.length && $nextHeading[0] === $header[0]) return;
        }

        var id = $header.attr('id');
        if (!id) {
          id = $header.text().toLowerCase()
            .replace(/[^\w\s]/g, '')
            .replace(/\s+/g, '-')
            .replace(/^-+|-+$/g, '');
          if (id) $header.attr('id', id);
        }
        if (id) {
          appendAnchorLink($header, '#' + id);
        }
      });
    }

    // API page only: Handle content H2/H3/H4 that don't have data-unique elements
    if ($('body').hasClass('api')) {
      $('#content h2, #content h3, #content h4').each(function () {
        var $header = $(this);

        // Skip if already has an anchor link
        if ($header.find('.anchor-link').length > 0) return;

        // Skip if this is handled by data-unique logic above
        if ($header.prev('[data-unique]').length > 0) return;

        // Skip Swagger operation headers (anchor/deep-link handling is done by Swagger UI)
        if ($header.hasClass('opblock-tag') || $header.hasClass('opblock-summary-operation-id')) return;

        if (shouldSkipHeaderForAnchors($header)) return;

        var headerId = $header.attr('id');
        if (!headerId) {
          // Generate ID from header text if none exists
          headerId = $header.text().toLowerCase()
            .replace(/[^\w\s]/g, '')
            .replace(/\s+/g, '-')
            .replace(/^-+|-+$/g, '');
          $header.attr('id', headerId);
        }

        if (headerId) {
          var hrefApi = '#' + headerId;
          appendAnchorLink($header, hrefApi);
        }
      });
    }
  }, 100); // Small delay to ensure DOM is ready

  // Swagger UI link icons: Swagger rebuilds DOM on expand/collapse, so we use
  // MutationObserver to re-inject icons when it changes.
  if ($('body').hasClass('api')) {
    (function() {
      var $apiContainer = $('#api');
      if (!$apiContainer.length) return;

      function addTagLinkIcon(tagEl) {
        var $tag = $(tagEl);
        if ($tag.find('> .swagger-link-icon').length) return;

        var dataTag = $tag.attr('data-tag');
        if (!dataTag) return;

        var $icon = $('<a>', {
          href: '#/' + dataTag,
          'class': 'anchor-link swagger-link-icon'
        }).append('<i class="fa fa-link"></i>');

        var $expandBtn = $tag.find('> button.expand-operation');
        if ($expandBtn.length) {
          $icon.insertBefore($expandBtn);
        } else {
          $tag.append($icon);
        }
      }

      function addOperationLinkIcon(opIdEl) {
        var $opId = $(opIdEl);
        if ($opId.find('> .anchor-link').length) return;

        var $opblock = $opId.closest('.opblock');
        if (!$opblock.length) return;

        var nodeId = $opblock.attr('id') || '';
        if (!nodeId || nodeId.indexOf('operations-') !== 0) return;

        // ID format: operations-Tag-operationId -> href: #/Tag/operationId
        var parts = nodeId.replace('operations-', '').split('-');
        if (parts.length < 2) return;

        var $icon = $('<a>', {
          href: '#/' + parts[0] + '/' + parts.slice(1).join('-'),
          'class': 'anchor-link swagger-link-icon'
        }).append('<i class="fa fa-link"></i>');

        $opId.append($icon);
      }

      function addAllSwaggerLinkIcons() {
        $apiContainer.find('h3.opblock-tag[data-tag]').each(function() {
          addTagLinkIcon(this);
        });
        $apiContainer.find('.opblock-summary-operation-id').each(function() {
          addOperationLinkIcon(this);
        });
      }

      setTimeout(addAllSwaggerLinkIcons, 500);

      var observer = new MutationObserver(function() {
        requestAnimationFrame(addAllSwaggerLinkIcons);
      });
      observer.observe($apiContainer[0], { childList: true, subtree: true });

      // Event capturing to intercept clicks before Swagger handles them
      $apiContainer[0].addEventListener('click', function(e) {
        var iconEl = e.target.closest('.swagger-link-icon');
        if (!iconEl) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          copyAnchorLink(iconEl.getAttribute('href'));
        }
        // If clipboard unavailable, allow default link behavior
      }, true);
    })();
  }

  // Scroll to in-page anchors
  $(document).on('click', 'a[href^="#"]', function (e) {
    try {
      if ($(this).hasClass('anchor-link')) {
        e.preventDefault();
        return;
      }
      var href = this.getAttribute('href').replace(/^#/, '');
      if (!href) return; // allow default for "#"

      // Skip tab navigation links - they have their own handler in ui-tabs.js
      if (this.getAttribute('rel') === 'tab') return;

      // Look for possible targets in priority order
      var $target = $(
        'div[data-unique="' + href + '"], div[name="' + href + '"], #' + escapeCSS(href)
      );

      // If not found and the href looks like a Swagger operation path ("/tag/operation"),
      // attempt to convert it to the corresponding element id generated by Swagger UI
      if (!$target.length && href.indexOf('/') === 0) {
        var rest = href.slice(1).replace(/\//g, '-');
        $target = $('#operations-' + rest + ', #operations-tag-' + rest);
      }

      if ($target.length) {
        e.preventDefault();
        var $first = $target.first();
        if ($first.offset()) {
          scrollPage($first);
          // Update URL only if it changed to avoid duplicate history entries
          setTimeout(function () {
            if (location.hash !== '#' + href) {
              history.pushState(null, null, '#' + href);
            }
          }, 100);
        }
        return; // handled
      }
      // If no target found, fall through and let browser handle default
    } catch (e) {
      // Ignore errors
    }
  });

  // Scroll to anchor on page load
  function applyHashOnLoad() {
    try {
      if (!location.hash || /^#\/.*/.test(location.hash)) return; // ignore swagger-style "/tag/operation"
      var id = DOMPurify ? DOMPurify.sanitize(location.hash.slice(1)) : location.hash.slice(1);
      var selector = 'div[data-unique="' + id + '"], div[name="' + id + '"], #' + escapeCSS(id);
      var $anchor = $(selector);
      if ($anchor.length && $anchor.first().offset()) {
        scrollPage($anchor.first());
      }
    } catch (e) {
      // Ignore errors
    }
  }
  setTimeout(applyHashOnLoad, TIMING.LAYOUT_DELAY);

  /**
   * Lightbox - initialize when featherlight is available (deferred script)
   */
  if (typeof $.fn.featherlight !== 'undefined') {
    $('a[rel="lightbox"]').featherlight({
      root: 'section#body'
    });
  }

});
